<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11" class="mx-auto my-6" align="center">
        <h2>Profil de {{ userNickname }}</h2>
        <v-divider></v-divider>
        <UserCalendar v-if="userId" :userId="userId"></UserCalendar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserCalendar from "@/components/UserCalendar.vue";
import { db } from "@/services/firebaseServices.js";
export default {
  data() {
    return {
      userNickname: this.$route.params.nickname,
      firstname: "",
      name: "",
      userId: "",
      sessions: []
    };
  },
  components: {
    UserCalendar
  },
  created() {
    this.getUserInfos();
  },
  watch: {
    $route: "getUserInfos"
  },
  methods: {
    getUserInfos() {
      //fetch user data from nickname
      const query = db
        .collection("users")
        .where("userData.nickname", "==", this.userNickname);
      query.get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = doc.data();
          this.firstname = data.userData.firstName;
          this.name = data.userData.name;
          this.userId = data.userId;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/variables";

.calendar {
  height: $calendarHeight;
  margin: 50px 30px;
  width: calc(100% - 60px);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-content: flex-start;
}
</style>